// ===== Packages =====

import {
    Node,
    Element,
}                   from 'slate';

// ===== Interfaces =====

import {
    EditorNode,
}                   from '.';

const implementsListableInterface = (node: EditorNode | Node): boolean => Element.isElement(node)
    && 'isListable' in node
    && !!node.isListable;

export default {
    implementsListableInterface,
};
